<template>
  <div class="flex-1 flex items-center justify-center p-6">
    <div class="text-center">
      <div class="loading-spinner mx-auto animate-spin"></div>
      <p v-if="message" class="mt-2 text-sm text-gray-500">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
  props: {
    message: {
      type: String,
      default: 'Loading...'
    }
  }
};
</script>

<style scoped>
.loading-spinner {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: conic-gradient(
    from 180deg,
    transparent 0deg,
    #C1D6F0 30deg,
    #21426C 360deg
  );
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px));
}
</style>
